import { ORDER_SET_PRODUCT_SKU } from './actionTypes'

export default function orderSetProductSku(payload) {
  return {
    type: ORDER_SET_PRODUCT_SKU,
    payload,
  }
}
